import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useRelativeLink(): void {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id: string = decodeURIComponent(hash.slice(1));
    let attempts = 0;

    const interval: number = window.setInterval(() => {
      const element = document.getElementById(id);

      if (element) {
        window.clearInterval(interval);

        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

        return;
      }

      attempts++;

      if (attempts >= 20) {
        window.clearInterval(interval);
        console.warn(`Element '#${id}' not found.`);
      }
    }, 250);

    return () => window.clearInterval(interval);
  }, [pathname, hash]);
}

export default useRelativeLink;